
import Users from "../gigprovider/gigproviderserachjoblisting";

const SeekerList=()=>{
    return (<><Users/></>);
}

export default SeekerList;